import { useContext } from "react";
import { createValidationResult, depascalize, usePerformMultipleActions } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../../common/types/FileRecordStatus";
import { validateFileRecordStatus } from "../../../../common/utils/validateFileRecordStatus";
import { FileRecordListingContext } from "../../../context/FileRecordListingContext";
import { FileRecordListingItem } from "../../../types/FileRecordListingItem";
import { mapFileRecordListingToStatusValidator } from "../utils/mapFileRecordListingToStatusValidator";
import { validateDiscardedFileRecords } from "../utils/validateDiscardedFileRecords";

export const useUpdateFileRecordsStatusDialog = (selectedStatus: FileRecordStatus) => {
    const {
        changeFileRecordToEditing,
        destroyFileRecord,
        changeFileRecordToQc,
        changeFileRecordToQcDone
    } = useFileRecordApi();

    const { selectedItems, updateFileRecordStatus } = useContext(FileRecordListingContext);

    const { performAllItems, isActionInProgress, items } = usePerformMultipleActions<FileRecordListingItem>({
        isAvailable: (item) => {
            return validateFileRecordStatus(mapFileRecordListingToStatusValidator(item), selectedStatus);
        },
        selectedItems
    });

    const failure = validateDiscardedFileRecords(items, selectedItems.length, selectedStatus);

    const validationResult = createValidationResult([failure]);

    const handleUpdateFileRecordStatus = async (fileRecordId: string) => {
        switch (selectedStatus) {
            case FileRecordStatus.Editing:
                await changeFileRecordToEditing({ fileRecordId });
                break;
            case FileRecordStatus.QcDone:
                await changeFileRecordToQcDone({ fileRecordId });
                break;
            case FileRecordStatus.Qc:
                await changeFileRecordToQc({ fileRecordId });
                break;
            case FileRecordStatus.Destroyed:
                await destroyFileRecord({ fileRecordId });
                break;
            default:
                break;
        }
        updateFileRecordStatus(fileRecordId, selectedStatus);
    };

    return {
        items,
        performAllItems,
        validationResult,
        isActionInProgress,
        handleUpdateFileRecordStatus,
        statusName: depascalize(FileRecordStatus[selectedStatus])
    };
};
